/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {
  DeleteMe200,
  UpdateCookieConsentRequest,
  UpdateUserRequest,
  UploadMyAvatarBody,
  UserResponse,
} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Returns the current user, creating a DB record if it doesn't exist yet
 */
export type getMeResponse200 = {
  data: UserResponse
  status: 200
}

export type getMeResponseSuccess = getMeResponse200 & {
  headers: Headers
}
export type getMeResponse = getMeResponseSuccess

export const getGetMeUrl = () => {
  return `/auth/me`
}

export const getMe = async (options?: RequestInit): Promise<getMeResponse> => {
  return customFetch<getMeResponse>(getGetMeUrl(), {
    ...options,
    method: 'GET',
  })
}

/**
 * Updates the current user's profile
 */
export type updateMeResponse200 = {
  data: UserResponse
  status: 200
}

export type updateMeResponseSuccess = updateMeResponse200 & {
  headers: Headers
}
export type updateMeResponse = updateMeResponseSuccess

export const getUpdateMeUrl = () => {
  return `/auth/me`
}

export const updateMe = async (
  updateUserRequest: UpdateUserRequest,
  options?: RequestInit,
): Promise<updateMeResponse> => {
  return customFetch<updateMeResponse>(getUpdateMeUrl(), {
    ...options,
    method: 'PATCH',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(updateUserRequest),
  })
}

/**
 * Deletes the current user's account
 */
export type deleteMeResponse200 = {
  data: DeleteMe200
  status: 200
}

export type deleteMeResponseSuccess = deleteMeResponse200 & {
  headers: Headers
}
export type deleteMeResponse = deleteMeResponseSuccess

export const getDeleteMeUrl = () => {
  return `/auth/me`
}

export const deleteMe = async (options?: RequestInit): Promise<deleteMeResponse> => {
  return customFetch<deleteMeResponse>(getDeleteMeUrl(), {
    ...options,
    method: 'DELETE',
  })
}

/**
 * Records the user's optional-cookie / analytics consent choice. localStorage stays the
synchronous gating source on the client; this endpoint mirrors the choice into the DB so
consent follows the user across devices and we have a GDPR Art. 7(1) audit record.
 */
export type updateMyCookieConsentResponse200 = {
  data: UserResponse
  status: 200
}

export type updateMyCookieConsentResponseSuccess = updateMyCookieConsentResponse200 & {
  headers: Headers
}
export type updateMyCookieConsentResponse = updateMyCookieConsentResponseSuccess

export const getUpdateMyCookieConsentUrl = () => {
  return `/auth/me/cookie-consent`
}

export const updateMyCookieConsent = async (
  updateCookieConsentRequest: UpdateCookieConsentRequest,
  options?: RequestInit,
): Promise<updateMyCookieConsentResponse> => {
  return customFetch<updateMyCookieConsentResponse>(getUpdateMyCookieConsentUrl(), {
    ...options,
    method: 'PATCH',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(updateCookieConsentRequest),
  })
}

/**
 * Uploads a new avatar image. JPEG/PNG/WebP, normalized to 640px JPEG q=80.
 */
export type uploadMyAvatarResponse200 = {
  data: UserResponse
  status: 200
}

export type uploadMyAvatarResponseSuccess = uploadMyAvatarResponse200 & {
  headers: Headers
}
export type uploadMyAvatarResponse = uploadMyAvatarResponseSuccess

export const getUploadMyAvatarUrl = () => {
  return `/auth/me/avatar`
}

export const uploadMyAvatar = async (
  uploadMyAvatarBody: UploadMyAvatarBody,
  options?: RequestInit,
): Promise<uploadMyAvatarResponse> => {
  const formData = new FormData()
  formData.append(`file`, uploadMyAvatarBody.file)

  return customFetch<uploadMyAvatarResponse>(getUploadMyAvatarUrl(), {
    ...options,
    method: 'POST',
    body: formData,
  })
}

/**
 * Deletes the current user's avatar.
 */
export type deleteMyAvatarResponse200 = {
  data: UserResponse
  status: 200
}

export type deleteMyAvatarResponseSuccess = deleteMyAvatarResponse200 & {
  headers: Headers
}
export type deleteMyAvatarResponse = deleteMyAvatarResponseSuccess

export const getDeleteMyAvatarUrl = () => {
  return `/auth/me/avatar`
}

export const deleteMyAvatar = async (options?: RequestInit): Promise<deleteMyAvatarResponse> => {
  return customFetch<deleteMyAvatarResponse>(getDeleteMyAvatarUrl(), {
    ...options,
    method: 'DELETE',
  })
}
